import React, { useEffect, useState } from "react";
import axios from "axios";

const TopPointsAnalytics = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = JSON.parse(localStorage.user || "{}")?.access_token;

  useEffect(() => {
    if (!token) return;

    axios
      .get(`${window.$domain}/api/method/get_top_representatives_by_points`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setData(res.data.message || []);
      })
      .catch((err) => {
        console.error("Error loading points analytics", err);
      })
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="bg-white p-6 rounded-xl shadow-lg">
      <h2 className="text-lg font-semibold mb-4 text-gray-800">
        💰 Top Representatives by Earned Revenue
      </h2>
      <div className="space-y-3 max-h-[460px] overflow-y-auto pr-1">
        {loading ? (
          <p className="text-sm text-gray-500 animate-pulse">Loading...</p>
        ) : data.length ? (
          data.map((rep, idx) => (
            <div
              key={rep.representative_profile}
              className="flex justify-between items-center bg-gray-50 border rounded-lg px-4 py-3 shadow-sm hover:shadow-md transition"
            >
              <div>
                <p className="font-medium text-gray-900">
                  {idx + 1}. {rep.full_name || "Unnamed"}
                </p>
                <p className="text-xs text-gray-500">{rep.email}</p>
              </div>
              <span className="font-semibold text-green-600">
                ${Number(rep.total_points / 100).toFixed(2)}
              </span>
            </div>
          ))
        ) : (
          <p className="text-sm italic text-gray-400">No data available</p>
        )}
      </div>
    </div>
  );
};

export default TopPointsAnalytics;
